// index.js ATUALIZADO

import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import store from "./redux/store";
import App from "./App";
import "./index.css";
import "./styles/nero-theme.css";
import "./styles/field-theme.css";
import "./styles/field-materials.css";
import "./styles/FieldPaper.css";
import "./styles/SheetComponents.css";
import "./styles/NotebookControls.css";
import { HelmetProvider } from 'react-helmet-async';
import { ToastProvider } from './components/notifications/ToastProvider';
import { ConfirmProvider } from './components/notifications/ConfirmProvider';
import '@fontsource/orbitron/latin-400.css';
import '@fontsource/orbitron/latin-500.css';
import '@fontsource/orbitron/latin-600.css';
import '@fontsource/orbitron/latin-700.css';
import '@fontsource/orbitron/latin-900.css';
import '@fontsource/rajdhani/latin-400.css';
import '@fontsource/rajdhani/latin-500.css';
import '@fontsource/rajdhani/latin-600.css';
import '@fontsource/rajdhani/latin-700.css';
import '@fontsource/roboto-condensed/latin-400.css';
import '@fontsource/roboto-condensed/latin-700.css';

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <ToastProvider>
          <ConfirmProvider>
            <App />
          </ConfirmProvider>
        </ToastProvider>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
);
